/**
 * Buy More, Save More - Variant Switcher
 * Switches between Single / Pack of 2 / Pack of 3 variants
 * and updates the displayed price accordingly
 */
(function() {
  'use strict';

  function init() {
    var containers = document.querySelectorAll('.as-bmsm');
    if (!containers.length) return;

    containers.forEach(function(el) {
      var radios  = el.querySelectorAll('.as-bmsm__radio');
      var options = el.querySelectorAll('.as-bmsm__option');

      function getVariantInput() {
        var form = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
        if (!form) return null;
        return form.querySelector('[name="id"]');
      }

      function formatMoney(cents) {
        var whole = Math.floor(cents / 100);
        var frac = cents % 100;
        if (frac < 10) frac = '0' + frac;
        return '\u00a3' + whole + '.' + frac;
      }

      function select(radio) {
        options.forEach(function(o) { o.classList.remove('as-bmsm__option--active'); });
        radio.closest('.as-bmsm__option').classList.add('as-bmsm__option--active');

        var qty = parseInt(radio.value, 10);
        var vid = el.getAttribute('data-vid-' + qty);
        var baseCents = parseInt(el.getAttribute('data-base'), 10);
        var priceCents;

        /* Get the correct price: for qty 1 use base, for others use pack total */
        if (qty === 1) {
          priceCents = baseCents;
        } else {
          var t = el.getAttribute('data-t' + qty);
          priceCents = t ? parseInt(t, 10) : null;
        }

        /* Switch the hidden variant ID input */
        if (vid && vid !== 'fallback') {
          var vidInput = getVariantInput();
          if (vidInput) {
            vidInput.value = vid;
            vidInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          /* Also try to trigger the theme's variant update for price display */
          dispatchVariantUpdate(vid);
        }

        /* Update the quantity input to 1 (since pack IS the bundle) */
        var qtyInput = getQtyInput();
        if (qtyInput) {
          qtyInput.value = 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

      }

      function getQtyInput() {
        var form = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
        if (!form) return null;
        return form.querySelector('[name="quantity"]') || form.querySelector('input[type="number"]');
      }

      function dispatchVariantUpdate(variantId) {
        /* Try to trigger the theme's variant update system */
        var productForm = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
        if (!productForm) return;

        /* Dispatch a variant update event that the theme's product-price listens for */
        var section = productForm.closest('.shopify-section') || productForm.closest('dialog');
        if (section) {
          var event = new CustomEvent('variant-update', {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: 1
            }
          });
          section.dispatchEvent(event);
        }

        /* Also update any visible price elements directly */
        try {
          var pp = document.querySelector('product-price');
          if (pp) {
            var priceEls = pp.querySelectorAll('.price');
            var el = document.querySelector('.as-bmsm');
            if (el) {
              var radio = el.querySelector('.as-bmsm__radio:checked');
              if (radio) {
                var qty = parseInt(radio.value, 10);
                var cents;
                if (qty === 1) {
                  cents = parseInt(el.getAttribute('data-base'), 10);
                } else {
                  cents = parseInt(el.getAttribute('data-t' + qty), 10);
                }
                if (!isNaN(cents)) {
                  priceEls.forEach(function(p) { p.textContent = formatMoney(cents); });
                }
              }
            }
          }
        } catch(e) {}
      }

      radios.forEach(function(r) {
        r.addEventListener('change', function() { select(r); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(init, 200);
  });
})();
